import { EChannels } from 'core/model/enums';
import type {
  IGetUploadFileResponse,
  IUploadChannelItem,
  IUploadFileParams,
  IUploadListItem,
} from 'core/model/interfaces/downloads-uploads';
import type { IGetUploadByFileTypeDTO, IUploadChannelItemDTO, IUploadListItemDTO } from './uploads.dto';

export const toUploadChannelItem = (item: IUploadChannelItemDTO): IUploadChannelItem => {
  const value: IUploadChannelItem = {
    channel: item.channelId,
    filePath: item.filePath,
    filename: item.downloadFilename,
  };

  return value;
};

export const populateFileList = (files: Array<IUploadChannelItem>): Array<IUploadChannelItem> => {
  const channels = Object.values(EChannels).filter(value => typeof value === 'number') as Array<EChannels>;

  const populatedFiles = channels.map(channel => {
    const existingFile = files.find(file => file.channel === channel);

    if (existingFile) {
      return existingFile;
    }

    const item: IUploadChannelItem = {
      channel,
      filePath: '',
      filename: null,
    };

    return item;
  });

  return populatedFiles;
};

export const mapDtoToUploadList = (dto: Array<IUploadListItemDTO>): Array<IUploadListItem> => {
  const list = dto.map((item): IUploadListItem => {
    const files = populateFileList(item.lastFiles.map(toUploadChannelItem));

    return {
      fileType: item.fileType,
      title: item.title,
      description: item.description,
      files,
    };
  });

  return list;
};

export const mapDtoToGetUploadFile = (dto: IGetUploadByFileTypeDTO): IGetUploadFileResponse => {
  const response: IGetUploadFileResponse = {
    date: dto.date,
    filePath: dto.filePath,
    templateUrl: dto.templateUrl,
    userName: dto.userName,
    filename: dto.downloadFilename,
  };

  return response;
};

export const toUploadFileParams = (params: IUploadFileParams) => {
  const { file, fileType } = params;

  const formData = new FormData();

  formData.append('file', file.blob);

  formData.append('fileType', fileType);

  return formData;
};
